module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "icon-demo",
    attrs: {
      "title": "Icon"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "滚动到具体位置",
      "code": _vm.code
    }
  }, [_c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$smoothScroll(300)
      }
    }
  }, [_vm._v("滚动到距离顶部300的位置")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "default",
      "description": "滚动到目标元素",
      "code": _vm.ele_code
    }
  }, [_c('div', {
    ref: "target"
  }, [_vm._v("# Target")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$smoothScroll(_vm.$refs.target)
      }
    }
  }, [_vm._v("滚动到目标元素")]), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$smoothScroll(_vm.$refs.target, 1000, -100)
      }
    }
  }, [_vm._v("偏移100px")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "default",
      "description": "滚动到顶部",
      "code": _vm.top_code
    }
  }, [_c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$smoothScroll()
      }
    }
  }, [_vm._v("滚动顶部")]), _vm._v(" "), _c('Btn', {
    nativeOn: {
      "click": function($event) {
        _vm.$smoothScroll(0, 200)
      }
    }
  }, [_vm._v("200ms滚到顶部")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-312a7cef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/SmoothScroll.vue
// module id = 630
// module chunks = 0